import { EImportSectionsTarget } from '@constants';
import type { ICourse } from '@sdk/contracts';
import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { AddSection } from '../AddSection';
import { ImportSection } from '../ImportSection';

import { DescriptionWrapper, EmojiWrapper, TitleWrapper } from './EmptySections.styles';

type EmptySectionsProps = {
  course: ICourse;
  target: EImportSectionsTarget;
};

export const EmptySections: React.FC<EmptySectionsProps> = ({ course, target }) => {
  const { t } = useTranslation('ManagerBaseContentDetailTranslations');

  return (
    <Flex
      style={{
        height: '50vh',
        justifyContent: 'center'
      }}
      vertical
      gap={16}
      align="center">
      <EmojiWrapper>
        <span role="img" aria-label="book">
          📚
        </span>
      </EmojiWrapper>
      <Flex style={{ maxWidth: '472px' }} vertical gap={8} align="center">
        <TitleWrapper>{t('EMPTY_CONTENT_TITLE')}</TitleWrapper>
        <DescriptionWrapper>{t('EMPTY_CONTENT_DESCRIPTION')}</DescriptionWrapper>
      </Flex>

      <Flex gap={8}>
        <AddSection course={course} target={target} />
        <ImportSection target={target} />
      </Flex>
    </Flex>
  );
};
